export default __webpack_public_path__ + "respweb/static/images/red-heart-gift.6fe6150b.png";